const actions = {
  SET_STATE: 'application/SET_STATE',
  SET_APP_CONFIG: 'application/SET_APP_CONFIG',
}

export default actions
